const HandSvg = ({
  borderColor = "#534741",
  fillColor = "#2a4dff",
  backColor = "#fff",
}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.21 45">
      <title>handmade</title>
      <g id="hand">
        {/* <polygon
          fill={borderColor}
          points="0 0 39.21 0 39.21 45 0 45 0 22.5 0 0"
        /> */}
        {/* <rect fill={backColor} x="1" y="1" width="37.21" height="43" /> */}
        <path d="M10,42.08V5.82l.84-.14A57.6,57.6,0,0,1,20,5c4.75,0,8.38,1.06,10.78,3.14a10.22,10.22,0,0,1,3.5,8,11,11,0,0,1-3.08,8.15C28.6,27,24.42,28.44,19.44,28.44a23.85,23.85,0,0,1-2.75-.12V42.08Zm6.66-19.44a18.84,18.84,0,0,0,2.86.18c3,0,8.05-.84,8.05-6.44,0-4.81-4.09-5.82-7.52-5.82a25.52,25.52,0,0,0-3.39.19Z" />
        <path
          fill={fillColor}
          d="M11,6.67A55.91,55.91,0,0,1,20,6c4.61,0,8,1,10.12,2.89a9.21,9.21,0,0,1,3.16,7.28,10,10,0,0,1-2.78,7.44c-2.46,2.53-6.48,3.82-11,3.82a16.57,16.57,0,0,1-3.75-.31v14H11Zm4.66,16.79a16.14,16.14,0,0,0,3.86.36c5.62,0,9.05-2.64,9.05-7.44,0-4.6-3.37-6.82-8.52-6.82a20.26,20.26,0,0,0-4.39.36Z"
        />
      </g>
    </svg>
  );
};

export default HandSvg;
